import Vue from 'vue'

const roundNumber = {
	install(Vue) {
		Vue.prototype.$roundNumber = (num, decimalPlaces=2) => {
      const p = 10 ** decimalPlaces;
      const m = (num * p) * (1 + Number.EPSILON);
      return Math.round(m) / p;
    }
	}
}

Vue.use(roundNumber);
